module.exports = __webpack_public_path__ + "img/fc.303e100c.png";